// sendRideRequest — iter89 (Phase 1).
//
// In iter87 this fired wa.me directly. iter89 brings the popup back: every
// ride request now opens the global <WhatsAppActionSheet /> via the queue
// below. The sheet handles guest verification + message building + dispatch.

const QUEUE_EVENT = "habano:wa-sheet-open";

export function sendRideRequest(destination, opts = {}) {
  if (typeof window === "undefined") return false;
  window.dispatchEvent(new CustomEvent(QUEUE_EVENT, {
    detail: {
      type: "ride",
      destination,
      businessId: opts.businessId || null,
      source: opts.source || "direct",
      pickup: opts.pickup || null,
    },
  }));
  return true;
}

export function sendBusinessContact(destination, opts = {}) {
  if (typeof window === "undefined") return false;
  window.dispatchEvent(new CustomEvent(QUEUE_EVENT, {
    detail: { type: "business", destination, businessId: opts.businessId || null, source: opts.source || "direct" },
  }));
  return true;
}

export function sendVendorContact(destination, opts = {}) {
  if (typeof window === "undefined") return false;
  window.dispatchEvent(new CustomEvent(QUEUE_EVENT, {
    detail: { type: "vendor", destination, source: opts.source || "direct" },
  }));
  return true;
}

// iter108 — Dedicated phone-circle popup. Used on My Places / Favorites /
// Saved / Friend Profile list cards. Renders the ContactPopup with two
// actions: Send Message + Call (both via wa.me).
export function openContactPopup(destination, opts = {}) {
  if (typeof window === "undefined") return false;
  window.dispatchEvent(new CustomEvent("habano:contact-open", {
    detail: { destination, source: opts.source || "direct" },
  }));
  return true;
}

export const WA_QUEUE_EVENT = QUEUE_EVENT;
